import { showNotification } from "./functions";

export function checkCustomSelectFields() {
  const customSelectFields = document.querySelectorAll(
    ".editor-form__custom-select"
  );
  const customSelectsToCheck = [
    "yarn-no-material-",
    "sequins-no-material-",
    "fabric-",
  ];
  let isValid = true;
  for (const select of customSelectFields) {
    for (const customSelect of customSelectsToCheck) {
      if (select.id.includes(customSelect)) {
        // Check if ID in data-id attribute
        if (select.getAttribute("data-id") || select.value == "") continue;
        showNotification(
          "error",
          "Please select values for all select fields.",
          3000
        );
        select.style.backgroundColor = "#ffcccc";
        isValid = false;
      }
    }
  }
  return isValid;
}

export function selectedDesignType() {
  const designType = document.querySelector("#design-type").value;
  return designType != 0;
}
